import MyPage from './MyPage';

export default MyPage;
